<template>
  <div id="app" class="container-fluid">
    <div class="row" v-if="loading" >
      <div class="col align-self-center text-center ">
        <square-loader />
      </div>
    </div>
    <div v-else>
      <div>
        <router-view :key="$route.fullPath"/>
      </div>
    </div>
  </div>
</template>

<script>
import iam from './iam';
import SquareLoader from './components/SquareLoader.vue';

export default {
  name: 'App',
  components: { SquareLoader },
  data() {
    return {
      loading: true,
      username: '',
    };
  },
  created() {
    if (sessionStorage.getItem('SessionToken')) {
      this.getUser().then((user) => {
        iam.setConnectedUser(user);
        if (user.username) {
          this.username = user.username;
          this.loading = false;
        } else {
          this.loading = false;
          this.$router.push('/username');
        }
      })
        .catch(() => {
          sessionStorage.removeItem('SessionToken');
        });
    }
    this.loading = false;
  },
  methods: {
    getUser() {
      return this.$http.get(`${import.meta.env.VITE_LCT_API_URL}/users/me`)
        .then(response => response.data);
    },
  },
};
</script>

<style>
body,html {
    margin: 0;
    padding: 0;
    font-size: 100%;
    background-color: #eff1f3;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100vh;
  background: no-repeat center center fixed url("/static/cool-background.png");
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
#app > div{
  min-height: 100vh;
}
.btn-link, .btn-link:hover{
  color: black;
}
#app .container{
  background-color: rgba(255,255,255,0.9);
  min-height: 100vh;
  -webkit-box-shadow: 0px -5px 19px -13px rgba(163,163,163,1);
  -moz-box-shadow: 0px -5px 19px -13px rgba(163,163,163,1);
  box-shadow: 0px -5px 19px -13px rgba(163,163,163,1);
}
#app .text-info{
  color: #00579a !important;
}
a{
  color: #5dc596;
}
a:hover{
  color: #5dc596;
  text-decoration: underline;
}

</style>
